export default "<div class='carouselItem' (click)='setFilter()'\n    >{{item.name}}</div>\n"